import { useState } from "react";
import axios from "axios";
import LoaderIcon from "../../utils/loader";
import SuccessModal from "../../utils/successModalMsg";
import Button from "../common/Button";

const MailSubscription = () => {
  // Form
  const [loading, setLoading] = useState(false);
  const [formError, setFormError] = useState([]);
  const [formData, setFormData] = useState({
    email: "",
  });

  const { email } = formData;

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    // declare the data fetching function
    const PostFormData = async () => {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      };

      const body = JSON.stringify({ email });

      try {
        const res = await axios.post(
          `${process.env.REACT_APP_API_URL}/email-subscription`,
          body,
          config,
        );
        setLoading(false);
        if (res.status === 201) {
          handleShow();
          setFormData({
            email: "",
          });
        }
      } catch (err) {
        console.log(err);
        setFormError(err.response.data.email);
        handleShow();
      } finally {
        setLoading(false);
      }
    };
    PostFormData();
  };

  //Modal
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setFormError([]);
    setShow(false);
  };
  const handleShow = () => setShow(true);

  return (
    <section className="cht-relative cht-bg-[#0f172a] cht-py-12 sm:cht-py-16 cht-border-y cht-border-slate-800 !cht-font-body">
      <div className="cht-max-w-7xl cht-mx-auto cht-px-4 sm:cht-px-6 lg:cht-px-8">
        <div className="cht-rounded-[24px] cht-bg-gradient-to-r cht-from-[#1e293b] cht-to-[#0f172a] cht-border cht-border-slate-700/80 cht-shadow-soft cht-p-6 sm:cht-p-10 lg:cht-p-12">
          <div className="cht-grid lg:cht-grid-cols-12 cht-gap-8 cht-items-center">
            
            {/* Title / Description (5 cols) */}
            <div className="lg:cht-col-span-5 cht-space-y-2 cht-text-left">
              <span className="cht-inline-flex cht-items-center cht-gap-1.5 cht-px-3 cht-py-1 cht-bg-blue-500/20 cht-text-blue-300 cht-rounded-full cht-text-xs !cht-font-bold cht-mb-2">
                Stay Ahead
              </span>
              <h3 className="!cht-font-heading cht-text-xl sm:cht-text-2xl md:cht-text-3xl !cht-font-extrabold cht-text-white cht-tracking-tight">
                Subscribe to Our Technical Newsletter
              </h3>
              <p className="!cht-font-body cht-text-xs sm:cht-text-sm cht-text-slate-400 cht-leading-relaxed cht-mb-0">
                Weekly deep dives on software architecture, accredited career tracks, and industry insights delivered straight to your inbox.
              </p>
            </div>

            {/* Input & Subscribe Form (7 cols) */}
            <div className="lg:cht-col-span-7">
              <form onSubmit={(e) => onSubmit(e)} className="cht-flex cht-flex-col sm:cht-flex-row cht-gap-3">
                <div className="cht-flex-1">
                  <input
                    type="email"
                    className="cht-w-full cht-bg-white/10 cht-border cht-border-white/20 focus:cht-border-[#3e57da] focus:cht-bg-white/15 cht-rounded-xl cht-px-4 cht-py-3.5 cht-text-sm cht-text-white cht-placeholder-slate-400 focus:cht-ring-2 focus:cht-ring-[#3e57da]/50 cht-outline-none cht-transition-all"
                    id="subscriber_email"
                    placeholder="Enter your work email address"
                    name="email"
                    onChange={(e) => onChange(e)}
                    value={email}
                    required
                  />
                </div>

                <Button
                  type="submit"
                  variant="primary"
                  size="md"
                  isLoading={loading}
                  className="cht-py-3.5 cht-px-7 cht-shrink-0"
                >
                  Join Newsletter
                </Button>
              </form>
            </div>

          </div>
        </div>
      </div>

      {show ? (
        <SuccessModal
          message="You have successfully subscribed to our email updates."
          errorMessage={formError}
          show={show}
          onClose={handleClose}
        />
      ) : null}
    </section>
  );
};

export default MailSubscription;

